import { getClientConfig } from "@axa-asia/hk-react-app-config/shared/get-config";

export default getClientConfig();
